import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'

export default function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string | null>(null)
  const navigate = useNavigate()

  const handleLogin = async () => {
    setLoading(true);
    setErrorMessage(null);

    const { data, error } = await supabase.auth.signInWithPassword({ email, password });
  
    if (error || !data?.user) {
      setErrorMessage("Invalid email or password.");
      setLoading(false);
      return;
    }
  
    // ⏳ Attendre que Supabase mette à jour la session
    await new Promise((resolve) => setTimeout(resolve, 400));
  
    setLoading(false);
    navigate("/conversations");
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') handleLogin()
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#f9fbfd] to-[#e7eff8] px-4">
      <div className="bg-white w-full max-w-md p-8 rounded-3xl shadow-lg border border-slate-100">
        <h1 className="text-2xl sm:text-3xl font-bold text-center mb-6">
          Access to the{" "}
          <span className="brand-gradient">ConnectLah</span>{" "}
          Platform
        </h1>
        <div className="space-y-4">
          <div>
            <label className="text-sm text-slate-700 block mb-1">Email</label>
            <input
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
              onKeyDown={handleKeyDown}
              className="w-full px-4 py-2 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-primary"
            />
          </div>

          <div>
            <label className="text-sm text-slate-700 block mb-1">Password</label>
            <input
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={e => setPassword(e.target.value)}
              onKeyDown={handleKeyDown}
              className="w-full px-4 py-2 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-primary"
            />
          </div>

          {errorMessage && (
            <p className="text-sm text-red-600 bg-red-50 border border-red-200 rounded px-3 py-2">
              {errorMessage}
            </p>
          )}

          <button
            onClick={handleLogin}
            disabled={loading}
            className="w-full py-2 brand-gradient-bg text-white font-semibold rounded-md transition disabled:opacity-60 hover:opacity-90"
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </div>
        <div className="text-right mt-2">
          <a
            href="/forgot-password"
            className="text-sm font-medium brand-gradient hover:underline"
          >
            Forgot password ?
          </a>
        </div>
      </div>
    </div>
  )
}
